/* eslint-disable no-return-assign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import axios from 'axios';
import qs from 'qs';

export default {
    formEl: null,
    data: () => ({
        dirty: false,
        success: false,
        successHeight: '',
    }),
    computed: {
        baseRenderProps() {
            return {
                registerFormEl: this.registerFormEl,
                onDirty: this.onDirty,
                dirty: this.dirty,
                success: this.success,
                successHeight: this.successHeight,
            };
        },
    },
    methods: {
        registerFormEl({ el }) {
            this.$options.formEl = el;
        },
        onDirty() {
            this.dirty = true;
        },
        updateSuccesHeight() {
            this.successHeight = `${this.$options.formEl.getBoundingClientRect().height}px`;
        },
        async mailchimpSubscribe({
            email,
            firstName = null,
            lastName = null,
            tags = null,
            mergeTags = null,
            groups = null,
        }) {
            const data = {
                email,
                [this.$global.csrfTokenName]: this.$global.csrfTokenValue,
                mcvars: {
                },
            };

            if (firstName) {
                data.mcvars.FNAME = firstName;
            }

            if (lastName) {
                data.mcvars.LNAME = lastName;
            }

            if (tags) {
                data.tags = tags.split(',');
            }

            if (mergeTags) {
                data.mcvars = { ...data.mcvars, ...mergeTags };
            }

            if (groups) {
                data.interests = {};
                for (const key in groups) {
                    if (groups.hasOwnProperty(key)) {
                        data.interests[key] = groups[key];

                        // unclear approach maybe based on MC API docs:
                        // data.interests[key] = {};
                        // groups[key].forEach(groupOpt => (data.interests[key][groupOpt] = true));
                    }
                }
            }

            // console.log(data);

            const res = await axios.post('/actions/mailchimp-subscribe/list/subscribe', qs.stringify(data));
            return res.data;
        },
    },
};
